import { render, staticRenderFns } from "./AdapterComponent.vue?vue&type=template&id=2b4bc4e6"
import script from "./AdapterComponent.vue?vue&type=script&lang=js"
export * from "./AdapterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports